import { elementNameVariants } from "./elementName.css";
import { ElementNameProps } from "./types";

const ElementName = ({ copnr, children }: ElementNameProps) => (
  <span
    className={
      copnr !== null ? elementNameVariants[copnr] : elementNameVariants.default
    }
  >
    {children}
  </span>
);

export default ElementName;
